import { Link } from "react-router-dom";
import { SITE, LOGO_MAIN } from "../content";
import { useLang } from "../lang";

export default function Footer() {
  const { lang } = useLang();
  const yr = new Date().getFullYear();
  return (
    <footer className="bg-[#f5f5f7] pt-14 pb-8 border-t border-[#d2d2d7]" data-testid="site-footer">
      <div className="max-w-[1200px] mx-auto px-6">
        <img src={LOGO_MAIN} alt="HGW Industry" className="h-8 mb-5 mx-auto md:mx-0" />
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-8 text-center md:text-left">
          <div>
            <p className="text-[13px] text-[#6e6e73] leading-relaxed max-w-xs mx-auto md:mx-0">
              {lang === "it"
                ? "HGW Industry — Produzione di finestre e serramenti in alluminio e PVC. Sistemi architettonici e soluzioni outdoor."
                : "HGW Industry — Manufacturing of aluminium and PVC windows and doors. Architectural systems and outdoor solutions."}
            </p>
          </div>
          <address className="not-italic text-[13px] text-[#6e6e73] leading-relaxed md:text-right" data-testid="footer-company">
            {SITE.fullName}<br />
            {SITE.headOffice.street} · {SITE.headOffice.zip} {SITE.headOffice.city} ({SITE.headOffice.province})<br />
            <a href={`mailto:${SITE.email}`} className="text-[#1D3F94] hover:underline">{SITE.email}</a>
          </address>
        </div>

        <div className="border-t border-[#d2d2d7] pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[12px] text-[#6e6e73]">
          <div className="flex items-center gap-3 flex-wrap justify-center md:justify-start">
            <span>© {yr} {SITE.fullName} — {lang === "it" ? "Tutti i diritti riservati." : "All rights reserved."}</span>
            <span className="text-[#d2d2d7] hidden md:inline">·</span>
            <a href={SITE.instagram} target="_blank" rel="noreferrer" className="hover:text-[#1d1d1f]" data-testid="footer-instagram">Instagram</a>
            <span className="text-[#d2d2d7] hidden md:inline">·</span>
            <a href={SITE.facebook} target="_blank" rel="noreferrer" className="hover:text-[#1d1d1f]" data-testid="footer-facebook">Facebook</a>
            <span className="text-[#d2d2d7] hidden md:inline">·</span>
            <Link to="/privacy" className="hover:text-[#1d1d1f]" data-testid="footer-privacy">Privacy</Link>
            <span className="text-[#d2d2d7] hidden md:inline">·</span>
            <Link to="/cookie" className="hover:text-[#1d1d1f]" data-testid="footer-cookie">Cookie</Link>
          </div>
          <div>{SITE.vat}</div>
        </div>
        <p className="mt-4 text-center md:text-left text-[11px] text-[#86868b]" data-testid="footer-cookie-note">
          {lang === "it" ? "Questo sito utilizza solo cookie tecnici, necessari al suo funzionamento. " : "This site uses technical cookies only, needed for it to work. "}
          <Link to="/cookie" className="underline hover:text-[#1d1d1f]">{lang === "it" ? "Cookie policy" : "Cookie policy"}</Link>
        </p>
      </div>
    </footer>
  );
}
